import { Menu, Layers } from 'lucide-react'
import { usePaletteStore } from '@/stores/palette-store'

interface MobileHeaderProps {
  onHamburger: () => void
}

export function MobileHeader({ onHamburger }: MobileHeaderProps) {
  const toggle = usePaletteStore((s) => s.toggle)

  return (
    <header className="flex h-14 shrink-0 items-center justify-between border-b border-sidebar-border bg-sidebar px-4 md:hidden">
      <button
        onClick={onHamburger}
        aria-label="Buka menu"
        className="rounded-md p-2 text-sidebar-foreground hover:bg-sidebar-accent transition-colors"
      >
        <Menu className="h-5 w-5" />
      </button>

      <div className="flex items-center gap-2">
        <div className="flex h-6 w-6 items-center justify-center rounded-md bg-sidebar-primary text-sidebar-primary-foreground">
          <Layers className="h-3.5 w-3.5" />
        </div>
        <span className="font-semibold text-sidebar-foreground">One Workspace</span>
      </div>

      <button
        onClick={toggle}
        aria-label="Buka command palette"
        className="rounded-md px-2 py-1.5 text-sidebar-foreground hover:bg-sidebar-accent transition-colors"
      >
        <kbd className="text-xs font-mono">⌘K</kbd>
      </button>
    </header>
  )
}
